import { render } from "./TicketsResolvedChart.vue?vue&type=template&id=4b63b503&ts=true"
import script from "./TicketsResolvedChart.vue?vue&type=script&lang=ts"
export * from "./TicketsResolvedChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__